var $60f372f660e937e4$exports = {};
$60f372f660e937e4$exports = {
    "(optional)": `(valinnainen)`,
    "(required)": `(pakollinen)`
};


export {$60f372f660e937e4$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
